import { IUnitData, UnitUNITVar } from "@/services/project/modal"
import { changeCondition, removeCondition } from "@/services/project/simulation.service"
import { ManualInputRow } from "../../common/ManualInputRow"
import { SpecialCondition } from "../../common/SpecialCondition/SpecialCondition"
import { DataActionBox } from "../../common/DataActionBox/DataActionBox"
import { AppDispatch } from "@/store"
import { useDispatch, useSelector } from "react-redux"
import { addManualInputThunk } from "@/store/flowsheet/actions"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"

interface OtherVarsProps {
  unitId: string
  data: IUnitData | undefined
  reloadData?: () => void
}

export function StreamOtherTab(props: OtherVarsProps) {
  const {unitId, data, reloadData} = props
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const unitData: UnitUNITVar = (data?.vars?.UNIT ?? {}) as any
  const unitOut = data?.vars?.OUT
  const dispatch = useDispatch<AppDispatch>()

  const onConditionChange = async (val?: string) => {
    if (val) {
      await changeCondition({
        conditions:[
          {unitId: unitId, attribute: ':OUT:LV_COND', value: val}
        ]
      }, {sId: flowSimulation?.id})
    } else {
      await removeCondition({
        conditions:[
          {unitId: unitId, attribute: ':OUT:LV_COND'}
        ]
      }, {sId: flowSimulation?.id})
    }
    reloadData?.()
  }

  const onReset = async () => {
    dispatch(addManualInputThunk({
      data: {dvars: [
        {unitId: unitId, attribute: ':UNIT:DP', value: 0},
        {unitId: unitId, attribute: ':UNIT:DT', value: 0},
        {unitId: unitId, attribute: ':UNIT:Q', value: 0},
        {unitId: unitId, attribute: ':UNIT:ds', value: 0},
      ]},
      params: {sId: flowSimulation?.id}
    }))
  }
  
  return <div>
    <DataActionBox onReset={onReset}>
      <ManualInputRow label="Pressure Drop" dimCode="DPRES" data={unitData.DP} attrKey=':UNIT:DP' unitId={unitId} reload={reloadData} />
      <ManualInputRow label="Temperature Delta" dimCode='DTEMP' data={unitData.DT} attrKey=":UNIT:DT" unitId={unitId} reload={reloadData}/>
      <ManualInputRow label="Heat input" dimCode='HEATFLOW' data={unitData.Q} attrKey=":UNIT:Q" unitId={unitId} reload={reloadData}/>
      <ManualInputRow label="Entropy Delta" dimCode='MOL_S' data={unitData.ds} attrKey=":UNIT:ds" unitId={unitId} reload={reloadData}/>
    </DataActionBox>
    
    <SpecialCondition className='mt-1' value={unitOut?.LV_COND || undefined} onChange={onConditionChange} />
  </div>
}